export const GET_ALL_TAGS = `query MyQuery {
    productTags(first: 100) {
      edges {
        node
      }
    }
  }
  `